import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LocalStorageTokenService} from '../services/utilisateurs/local-storage-token.service';
import jwt_decode from 'jwt-decode';
import {TokenModel} from '../models/identification/token.model';
import {UtilisateurCourantService} from '../services/utilisateurs/utilisateur-courant.service';
import {finalize, switchMap} from 'rxjs/operators';

const deltaSecondsForRefresh = 600; // 10 minutes

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenInterceptorService implements HttpInterceptor {
  private tokenBeingRefreshed = false;

  constructor(
    private tokenStore: LocalStorageTokenService,
    private utilisateurCourantService: UtilisateurCourantService,
  ) {}

  static hasTokenToBeRefresh(token: TokenModel): boolean {
    const dataFromToken: {exp: number} = jwt_decode(token.value);
    const timeSecondsExpire = dataFromToken.exp;
    const timeSecondsNow = new Date().getTime() / 1000;
    const deltaSeconds = timeSecondsExpire - timeSecondsNow;
    return deltaSeconds > 0 && deltaSeconds < deltaSecondsForRefresh;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.tokenBeingRefreshed) {
      const token = this.tokenStore.getCurrentToken();
      if (token && token.value && RefreshTokenInterceptorService.hasTokenToBeRefresh(token)) {
        this.tokenBeingRefreshed = true;
        return this.utilisateurCourantService.refreshToken().pipe(
          finalize(() => (this.tokenBeingRefreshed = false)),
          switchMap(() => next.handle(req)),
        );
      }
    }

    return next.handle(req);
  }
}
